import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import updateSingleDatasetInView from './updateSingleDatasetInView';
export default function updateMultipleDatasetsInView(view, data) {
  Object.keys(data).forEach(function (name) {
    updateSingleDatasetInView(view, name, data[name]);
  });
}